"use client";
import { useMemo } from "react";

import clsx from "clsx";

import { Column } from "@/components/containers";
import { Accordion } from "@/components/displays";

import { Question, QuestionId, questions } from "./consts";
import styles from "./QuestionSection.module.scss";

export interface QuestionSectionProps {
  questionIds: QuestionId[];
}

export function QuestionSection(props: QuestionSectionProps): React.ReactNode {
  const { questionIds } = props;

  const filteredQuestions = useMemo(
    () =>
      questionIds
        .map((id) => questions.find((question) => question.id === id))
        .filter(Boolean) as Question[],
    [questionIds]
  );
  return (
    <Column className={styles.container}>
      {filteredQuestions.map((question) => {
        return (
          <Accordion key={question.id} title={question.title} className={styles.accordion}>
            <Column className={styles.questions}>
              <span className={clsx(styles.descriptionText)}>{question.body}</span>
              {question.caution && (
                <p className={clsx(styles.descriptionText, "text__s text__gray__dark mg__top__s")}>
                  ※{question.caution}
                </p>
              )}
            </Column>
          </Accordion>
        );
      })}
    </Column>
  );
}
